export class IndexModel {
  GetJournalList: string = "";
  VolumeIssueListAPI: string = "";
  JournalAPI: string = "";
  DashboardApi: string = "";
  VendorallocteApi: string = "";
  VendorallocteListApi: string = "";
  InboxApi: string = "";
  DownloadApi: string = "";
  MultiDownloadApi: string = "";
  UploadApi: string = "";
  PartialUploadMsg: string = "";
  FailedMsg: string = "";
}


export class LogInfo {
  AllocateDate: string = "";
  DueDate: string = "";
  DownloadDate: string = "";
  UploadDate: string = "";
  UploadPackage: string = "";
  UploadStatus: string = "";
  ValidateStatus: string = "";
  FailureLogFile: string = "";
  Remarks: string = "";
}
